import React, { Component } from 'react';
class LogoSmall extends Component {
  spark1;
  spark2;
  spark3;
  sparks;

  constructor(props) {
    super(props);
    this.state = {
      isAnimating: false
    };
  }

  componentDidMount() {
    this.spark1 = document.querySelector('#mh-logo-small .spark-1');
    this.spark2 = document.querySelector('#mh-logo-small .spark-2');
    this.spark3 = document.querySelector('#mh-logo-small .spark-3');
    this.sparks = [this.spark1, this.spark2, this.spark3];
    setTimeout(() => {
      this.animate();
    }, this.props.animationDelay * 1000 + 1);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  animate() {
    TweenMax.to(this.spark1, 0.3, {
      x: '-=15',
      y: '-=15',
      rotation: '-=10',
      ease: Quart.easeOut
    });
    TweenMax.to(this.spark2, 0.3, {
      y: '-=18',
      ease: Quart.easeOut
    });
    TweenMax.to(this.spark3, 0.3, {
      x: '+=15',
      y: '-=15',
      rotation: '+=10',
      ease: Quart.easeOut,
      onComplete: () => {
        TweenMax.to(this.spark3, 0.15, {
          x: '-=15',
          y: '+=15',
          rotation: '-=10',
          ease: Quart.easeIn,
          delay: 0.25
        });
        TweenMax.to(this.spark2, 0.15, {
          y: '+=18',
          ease: Quart.easeIn,
          delay: 0.25
        });
        TweenMax.to(this.spark1, 0.15, {
          x: '+=15',
          y: '+=15',
          rotation: '+=10',
          ease: Quart.easeIn,
          delay: 0.25,
          onComplete: () => {
            setTimeout(() => {
              this.animate();
            }, this.props.animationDelay * 1000);
          }
        });
      }
    });
  }

  render() {
    return (
      <svg
        x="0px"
        y="0px"
        viewBox="0 0 501 118"
        style={{ overflow: `visible` }}
      >
        <title>Mini Heroes</title>
        <g id="mh-logo-small" transform="translate(-19.000000, -22.000000)">
          <g transform="translate(19.000000, 22.000000)">
            <g id="Group-27" transform="translate(473.000000, 0.000000)">
              <g id="Clip-26" />
              <image
                width="11"
                height="25"
                className="spark spark-2"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAZCAYAAADnstS2AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAGpJREFUeNpiYMADVKXZ/oMwjM+ITyEy//bTX4xMDEQCkGYmYkyFAaJNplwxLieQbDIjsaaSFHREOwNkKopifE6gTTjDnABXTIwTCJqMbCpYMbGmUs+D6E6gcxLF5QTSTcZlClEm49MMEGAA9JIldFS6bFoAAAAASUVORK5CYII="
              />
            </g>
            <path
              id="Fill-28"
              className="spark spark-3"
              fill="#251B06"
              d="M501,20.7c0-0.5-0.1-1-0.4-1.4c-0.8-0.8-1.8,0-2.6,0.6c-3.1,2.1-5.9,4.8-9,7c-0.6,0.4-5.2,4.2-3.3,4.8c-0.2-0.1-1.6,2.7,0.2,3.2c1.6,0.5,2.9-1.3,4-2.2c2.3-2,4.6-3.8,6.9-5.7c1-0.8,2.5-1.6,3.3-2.6c0.3-0.4,0.7-0.6,0.7-1.1c0-0.1-0.3-1.2-0.5-1C500.6,22,500.9,21.3,501,20.7"
            />
            <path
              id="Fill-30"
              className="spark spark-1"
              fill="#251B06"
              d="M462.7,15.2c-0.6-3.2-1.3-6.3-1.8-9.5c-0.2-1.6-0.1-3.1-1.5-4.2c-1.1-0.9-2.2-0.6-2.8,0.8c-1.3,3-0.3,5.6,0.3,8.6c0.2,0.9,0.4,1.7,0.6,2.5c0.4,1.8,1,3.5,1.5,5.3c0.3,1.1,0.8,3.4,1.8,4.1c0.9,0.6,1.7-0.5,1.8-1.4c0-0.5-0.2-1-0.1-1.5c0-0.5,0.3-0.9,0.4-1.3C463.1,17.5,462.9,16.2,462.7,15.2"
            />
            <g id="Group-34" transform="translate(428.000000, 29.000000)">
              <g id="Clip-33" />
              <image
                width="53"
                height="89"
                id="Fill-32"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAABZCAYAAACe0GxRAAAACXBIWXMAAAsSAAALEgHS3X78AAAA            GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAmJJREFUeNrsW0FywyAMNBqmn+i5/39Qz/1EL+344Jk0Y0AgLVpIOSaOzbKrlZBJOgzj4/3t5/mzz6/vdASP5AmoNbSAtfcu3S/NAoQe            jwDl2GQ8LnT2XCEWNpNVelHGUFq0cz6CYCkK0HYxNQyKwfU08peVpKdd1NeWX7T0tM8/r9uSqeQV            nAwsLRNTI7J/TaOIlF5pv9aag6wmO40cl5VfjS1hlF6Ljdr35iqdTZ7XossKLPU+W1YwBw2w7XoU            z4CFRXo1lq7vtPPI7LLT9CSWyVMaVkrXSLT0Rvdpw8k3Oo5GF5Ta/XriqAhqpvSQ7YHl8pRmoYUt            lqyA/oBi6ZEvKT80S9v2KNIKCbd3Pik6nhDvjhOTSfQArM0xW6lG5qBRUxHGN+3WBRYPjbPVftm7            V8BQG2bPh3kBtqolM8jFW/5y90BNE57ZMKTHSlm39l21H3tl0QQVyZblhYC5So+Spav8tCAs0kEk            e2mtuBVAjUVUzoOf1RsFZTGwsJ2vBpBrM9Mr8HtObd5dO7z1qE1opn2X2swjc8hWCaC3KiP3T6iH            j8rp/J3VFYXJGKYkXzZX7G47I6XnUV5RdWg9ZEd1jkJTfSPShjso70mO3E9QbPQcx+n9HJ6n7kwi            Io5g8tMAmrGhTEgjiIrLkORbm7QHk1QVhZc0E5P0vEAJCwOeBjIl+bYqB29HFBbphVu6JhdZ/4C8            rPuhErEgpIeqvmHyK20I0Qc+aOTnXX1PY6qXrRmy/P/zci25RscRhKnZVUN4QTvb3uExFZGvoDvf            qAQsOzHkwlQrby1j6cwMXeNXgAEAVNjixlu8Z0cAAAAASUVORK5CYII="
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

export default LogoSmall;



// WEBPACK FOOTER //
// ./src/svg/logo-small.js